import {useSettingsQuery} from '../../../common/providers/ApiInterface'

export const useDepartmentDetails = (departmentUpmId?: string) => {
  return useSettingsQuery('upmDepartmentDetails', [departmentUpmId], {
    enabled: !!departmentUpmId,
    gcTime: 0,
    retry: false,
    staleTime: 0
  })
}

export const QueryKey = 'departmentDetails'
